import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DescriptionIcon from "@mui/icons-material/Description";
import SidebarButton from "../sidebarButton/SidebarButton";
import Button from "./Button";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../store/reducerSlices/userSlice";
import { adminLogout } from "../store/reducerSlices/adminSlice";
import { setOpenMobileSidebar } from "../store/reducerSlices/hamburgerSlice";
import { centerStudentsPath } from "../helpers/adminPaths";

// toast
import { toast } from "react-toastify";

const AdminSidebar = () => {
  const [loggingOut, setLoggingOut] = useState(false);
  const location = useLocation();
  const [activeButton, setActiveButton] = useState("Admin");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const admin = useSelector((state) => state.admin.admin);

  // /admin lists admins. For an administrator that is every admin in the system, but for a
  // partner center admin the backend narrows it to their own center, so the entry is named
  // for what they actually see there.
  const isPartnerCenter = admin?.role === "PartnerCenter";
  const rosterTitle = isPartnerCenter ? "Center Team" : "Admin";
  const RosterIcon = isPartnerCenter ? GroupsRoundedIcon : HomeRoundedIcon;

  // A partner center's students live under its own url, /admin/<center-slug>, so the nav
  // keeps them there instead of bouncing back to the shared /admin/students.
  const studentsPath = centerStudentsPath(admin);

  const { isSidebarCollapsed, openMobileSideBar } = useSelector(
    (state) => state.hamburger
  );
  // console.log('isSidebarCollapsed', isSidebarCollapsed)
  // console.log('openMobileSideBar', openMobileSideBar)

  useEffect(() => {
    if (location.pathname === studentsPath) {
      setActiveButton("Students");
      return;
    }

    switch (location.pathname) {
      case "/admin":
        setActiveButton("Admin");
        break;
      case "/admin/students":
        setActiveButton("Students");
        break;
      case "/admin/profile":
        setActiveButton("Profile");
        break;

      default:
        setActiveButton("");
        break;
    }
  }, [location.pathname, studentsPath]);

  const handleLogout = () => {
    setLoggingOut(true);
    try {
      dispatch(userLogout());
      dispatch(adminLogout());

      setTimeout(() => {
        // navigate('/abc')
        navigate("/admin/login");
        // window.location.reload()
        toast.success("Logged Out Successfully");
      }, 1000);
      // navigate('/admin');
      // window.location.reload()
      // toast.success('Logged Out Successfully')
    } catch (error) {
      console.error("Navigation error:", error);
      toast.error("Logged Out Failed");
    }
  };

  return (
    <>
      {openMobileSideBar ? (
        <div className=" w-full h-lvh text-white sticky left-0 flex">
          <div className="w-5/6  bg-primary-title h-full">
            <Link to="/admin">
              <div
                className={` ${
                  isSidebarCollapsed ? "mt-10 " : ""
                }flex justify-center`}
              >
                <img
                  src="/assets/images/Logo.png"
                  alt="Logo"
                  className={`h-16 ${isSidebarCollapsed ? "hidden " : "block"}`}
                />
              </div>
            </Link>
            <div className="mt-10">
              {(admin?.role === "Administrator" || isPartnerCenter) && (
                <Link to="/admin">
                  <SidebarButton
                    icon={RosterIcon}
                    title={rosterTitle}
                    isActive={activeButton === "Admin"}
                    onClick={() => {
                      setActiveButton("Admin");
                      dispatch(setOpenMobileSidebar());
                    }}
                  />
                </Link>
              )}

              <Link to={studentsPath}>
                <SidebarButton
                  icon={WorkspacePremiumRoundedIcon}
                  title="Students"
                  isActive={activeButton === "Students"}
                  onClick={() => {
                    setActiveButton("Students");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
              <Link to="/admin/profile">
                <SidebarButton
                  icon={AccountCircleRoundedIcon}
                  title="Profile"
                  isActive={activeButton === "Profile"}
                  onClick={() => {
                    setActiveButton("Profile");
                    dispatch(setOpenMobileSidebar());
                  }}
                />
              </Link>
            </div>
            <div
              className="absolute bottom-5 w-5/6 mb-32 sm:mb-0"
              onClick={handleLogout}
            >
              <button
                type="button"
                className="bg-[#9A3C3C] flex justify-center  p-2 px-4 text-lg text-white font-poppins w-full"
              >
                {loggingOut ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-7 h-7 me-3 text-white animate-spin "
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="#E5E7EB"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="currentColor"
                    />
                  </svg>
                ) : (
                  <span>Logout</span>
                )}
              </button>

              {/* <Button title="Logout" className="rounded-md bg-[#9A3C3C] w-full" /> */}
            </div>
          </div>
          <div
            className="w-1/6 bg-neutral-700 opacity-45"
            onClick={() => dispatch(setOpenMobileSidebar())}
          ></div>
        </div>
      ) : (
        <div
          className={`p-5 bg-[#F6F8F9] h-screen sticky top-0 transition-all duration-300    md:${
            isSidebarCollapsed ? "w-20  " : "md:w-64 lg:w-72  "
          }  `}
        >
          <Link to="/admin">
            <div
              className={` ${
                isSidebarCollapsed ? "mt-10 " : ""
              }flex justify-center`}
            >
              <img
                src="/assets/images/Logo.png"
                alt="Logo"
                className={`h-16 ${isSidebarCollapsed ? "hidden " : "block"}`}
              />
            </div>
          </Link>
          <div className="mt-10">
            {(admin?.role === "Administrator" || isPartnerCenter) && (
              <Link to="/admin">
                <SidebarButton
                  icon={RosterIcon}
                  title={rosterTitle}
                  isActive={activeButton === "Admin"}
                  onClick={() => {
                    setActiveButton("Admin");
                  }}
                />
              </Link>
            )}
            <Link to={studentsPath}>
              <SidebarButton
                icon={WorkspacePremiumRoundedIcon}
                title="Students"
                isActive={activeButton === "Students"}
                onClick={() => {
                  setActiveButton("Students");
                }}
              />
            </Link>
            <Link to="/admin/profile">
              <SidebarButton
                icon={AccountCircleRoundedIcon}
                title="Profile"
                isActive={activeButton === "Profile"}
                onClick={() => {
                  setActiveButton("Profile");
                }}
              />
            </Link>
          </div>
          <div
            className={`absolute md:bottom-32 lg:bottom-5   ${
              isSidebarCollapsed ? "md:w-12 " : "md:w-44 lg:w-60 "
            }`}
            onClick={handleLogout}
          >
            <button
              className={`bg-[#9A3C3C] w-full px-4 text-lg text-white rounded-xl font-poppins flex justify-center items-center ${
                isSidebarCollapsed ? "p-3" : "p-2"
              }`}
              type="button"
            >
              {loggingOut ? (
                <svg
                  aria-hidden="true"
                  role="status"
                  className="inline w-7 h-7 me-3 text-white animate-spin "
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="#E5E7EB"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentColor"
                  />
                </svg>
              ) : (
                <span>
                  {!isSidebarCollapsed && <span>Logout</span>}
                  <i
                    className={`fa-solid fa-arrow-right-from-bracket  ${
                      isSidebarCollapsed ? "" : "ml-12"
                    }`}
                  ></i>
                </span>
              )}
            </button>
            {/* <Button title="Logout" className="rounded-md bg-red-600 w-full" /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default AdminSidebar;
